import { IPhoto } from "../data_models/iphoto";
import { Util } from "../../common_utils/util";
import { ITabViewTranslator } from "./itranslator";
import { IAlbum, IOwnedAlbum } from "../data_models/ialbum";

/**
 * This class is mainly used to translate all the source json responses to common model
 */

export class GatewayTranslator implements ITabViewTranslator{
  
  /** translates to UA asset format
   * 
   * @param {*} response
   * @returns {*}
   * @memberof GatewayTranslator
   */
  translateClusterAssets(params:any, response: any): any {    
        let photoList: Array<IPhoto> = []
        let entities = response.entities;
        for (let photo of entities) {        
            photoList.push(this.translatePhoto(photo));
        }  

        response = {
            entities: photoList,
            entityMap: {},
            results: [],
            errorId: response.errorId || null,
            errors: response.errors || [],
            nextUrl : response.next,
            isOnScroll: params.append || false
        }    
        return response;
    }
    /**
     * Method will translate the photo to common model structure
     *
     * @param {*} data
     * @returns {IPhoto}
     * @memberof GatewayTranslator
     */
    translatePhoto(data: any): IPhoto {
        let photo =  {
            id: data.id,
            documentId: data.documentId,
            createDate: data.createDate,
            dateTaken: data.dateTaken,
            updateDate: data.updateDate,
            version: data.version || "",
            dataCenter: data.dataCenter,
            ownerAccountId: data.accountId,
            userTags: data.userTags || [
                { value: data.name, key: "userFileName" }, 
                { value: data.name, key: "caption" }, 
                { value: data.name, key: "fileName" }
            ],
            systemTags: [{ value: data.isFavorite || false, key: "isFavorite" }],
            partnerAccountId: data.partnerAccountId || "",
            currentImageInfo: data.currentImageInfo || [],
            exifTags: data.exifTags || [],
            assetType: "PICTURE",
            files: [//Instagram does not provide height and width for image therefore setting the height and width to default 800.
                {fileType : "THUMBNAIL", width : data.lrWidth || data.width || 800, height : data.lrHeight || data.height || 800, url : data.url,size: data.size},
                {fileType : "HIRES", width : data.width || 800, height : data.height || 800, url : data.url}
            ],
            albumIds: [],
            faces: data.faces || [],
            assetSource: data.assetSource,
            assetId : data.assetId,
            mimeType: data.mimeType,
            timeStamp:Util.getCurrentTime()
        }      
        if(data.reportingMediaSource){
            photo["reportingMediaSource"] = data.reportingMediaSource
        }
        return photo;
    }
    /**
     * Method will translate the albums to the common models
     * @param params 
     * @param response 
     */
    translateAlbums(params:any, response: any): any{
        let albumList: Array<IAlbum> = []
        let entities = response.entities;
        for (let album of entities) {        
            albumList.push(this.translateAlbum(album));
        }  

        response = {
            entities: albumList,
            entityMap: {},
            results: [],
            errorId: response.errorId || null,
            errors: response.errors || [],
            nextUrl : response.next,
            isOnScroll: params.append || false
        }    
        return response;
    }
    /**
     * Method will translate the source album to common model format
     * @param entity 
     */
    translateAlbum(entity: any): any{
        const album: IOwnedAlbum = {
            albumId: entity.albumId,
            url: entity.firstAssetId || entity.url,
            source: entity.source,
            accountId: 0,
            updateDate: entity.createDate,
            createDate: entity.updateDate,
            dataCenter: "",
            systemTags: [],
            userTags: [{ key: "caption", value: entity.name }],
            photoCount: entity.photoCount,
        };

        //In all albums api , we wont get firstPhoto information          
        album.firstAssetId = {
            assetId: entity.firstAssetId,
            ownerId: entity.accountId,
            assetSource: entity.source,
            thumbnailEncryption: entity.firstAssetId
        };          
        return album;
    }
    /**
     * Method will translates the source album to common album model
     * @param response 
     */
    translateSingleAlbum(response: any): any{
        return this.translateAlbum(response);
    }
      
}